import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import EntityImage from './EntityImage';

const entityName = entity => entity.name || entity.title;

class EntityItem extends React.Component {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.select = this.select.bind(this);
  }

  select() {
    this.props.onSelect(this.props.entity.id);
  }

  render() {
    const { entity } = this.props;
    return (
      <tr>
        <td className="nine wide">
          <h3 className="ui image header">
            <EntityImage entity={entity} />
            <div className="content">{entityName(entity)}</div>
          </h3>
        </td>
        <td className="two wide" />
        <td className="three wide right aligned">
          <div className="ui tiny buttons">
            <button
              className="ui primary labeled icon button"
              onClick={this.select}
            >
              <i className="checkmark icon" />Sélectionner
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

export default pure(EntityItem);



// WEBPACK FOOTER //
// ./src/modules/catalog/components/EntityItem.js